<template>
  <CustomCreateDialog
    dialogTitle="ایجاد تخفیف حجمی جدید"
    dialogId="create-volume-discount-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="createNewVolumeDiscount"
  >
    <BCol cols="12">
      <DiscountTypePicker
        v-model="newVolumeDiscountPayload.discountType"
      ></DiscountTypePicker>
    </BCol>
    <BCol cols="12">
      <VolumeDiscountTypePicker
        v-model="newVolumeDiscountPayload.volumeDiscountType"
      ></VolumeDiscountTypePicker>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        customRules="required|min:1"
        inputId="discountValue"
        :inputLabel="handleDiscountValueInputLabel"
        :inputPlaceholder="handleDiscountValueInputPlaceholder"
        v-model="newVolumeDiscountPayload.discountValue"
      >
        <template #append>
          {{ handleDiscountValueInputAppend }}
        </template>
      </CustomAppendText>
    </BCol>
    <BCol cols="12">
      <TextInput
        customRules="required|min:1"
        inputId="minOrderQuantity"
        :inputLabel="handleMinOrderQuantityInputLabel"
        inputPlaceholder="5"
        v-model="newVolumeDiscountPayload.minOrderQuantity"
      ></TextInput>
    </BCol>
    <BCol cols="12">
      <CustomAppendText
        :isText="true"
        customRules="required|min:1"
        inputId="minTotalPrice"
        inputLabel="حداقل مبلغ سفارش"
        inputPlaceholder="500000"
        v-model="newVolumeDiscountPayload.minTotalPrice"
      >
        <template #append> تومان </template>
      </CustomAppendText>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  data() {
    return {
      newVolumeDiscountPayload: {
        volumeDiscountType: 1,
        discountType: 1,
        discountValue: null,
        minOrderQuantity: null,
        minTotalPrice: null,
      },
      volumeDiscountPersianTypes: {
        1: "درس",
        2: "دوره",
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async createNewVolumeDiscount() {
      try {
        this.isOkButtonDisabled = true;
        let _this = this;
        let createANewVolumeDiscount = new CreateANewVolumeDiscount(_this);
        createANewVolumeDiscount.setRequestParamDataObj(
          _this.newVolumeDiscountPayload
        );
        await createANewVolumeDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تخفیف حجمی با موفقیت ایجاد شد.",
              },
            });
            _this.newVolumeDiscountPayload = {
              volumeDiscountType: 1,
              discountType: 1,
              discountValue: null,
              minOrderQuantity: null,
              minTotalPrice: null,
            };
            this.$bvModal.hide("create-volume-discount-dialog");
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  computed: {
    handleDiscountValueInputPlaceholder() {
      return this.newVolumeDiscountPayload.discountType == 1 ? "10000" : "5";
    },
    handleDiscountValueInputAppend() {
      return this.newVolumeDiscountPayload.discountType == 1 ? "تومان" : "%";
    },
    handleDiscountValueInputLabel() {
      return `مقدار تخفیف (${
        this.newVolumeDiscountPayload.discountType == 1 ? "مبلغ" : "درصد"
      })`;
    },
    handleMinOrderQuantityInputLabel() {
      return `حداقل تعداد ${
        this.volumeDiscountPersianTypes[
          this.newVolumeDiscountPayload.volumeDiscountType
        ]
      } در سفارش`;
    },
  },
  components: {
    CustomCreateDialog,
    DiscountTypePicker,
    VolumeDiscountTypePicker,
    CustomAppendText,
    BCol,
    TextInput,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import DiscountTypePicker from "@/views/components/Discount/DiscountTypePicker.vue";
import VolumeDiscountTypePicker from "@/views/components/VolumeDiscounts/VolumeDiscountTypePicker.vue";
import CustomAppendText from "@/views/components/Utils/CustomAppendText.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { CreateANewVolumeDiscount } from "@/libs/Api/VolumeDiscounts";
</script>
